import { ValueUpdater } from '../../../../valueUpdater';
import { VehicleV11 } from '../../vehicle/model/vehicleV11';
import { JobV11 } from './jobV11';
import { SchedulingInformationV11 } from './schedulingInformationV11';
export class CaseV11 {
    static constructFromPlainObject(source) {
        const jobs = source.jobs ? source.jobs.map((j) => JobV11.constructFromPlainObject(j)) : [];
        const newCase = new CaseV11(source.externalId, source.title, ValueUpdater.getDateValue(source.createdAt), source.createdByUserId, source.createdByUserName, ValueUpdater.getDateValue(source.modifiedAt), source.assignedUserId, source.assignedUserName, jobs);
        const vehicle = source.vehicle ? VehicleV11.fromPlainObject(source.vehicle) : source.vehicle;
        newCase.vehicle = ValueUpdater.updateNullableField(newCase.vehicle, vehicle);
        newCase.assignedDistributionPartnerNumber = ValueUpdater.updateNonNullableString(newCase.assignedDistributionPartnerNumber, source.assignedDistributionPartnerNumber);
        newCase.assignedOutletNumber = ValueUpdater.updateNonNullableString(newCase.assignedOutletNumber, source.assignedOutletNumber);
        newCase.assignedBusinessPartnerId = ValueUpdater.updateNonNullableString(newCase.assignedBusinessPartnerId, source.assignedBusinessPartnerId);
        newCase.brand = ValueUpdater.updateNullableString(newCase.brand, source.brand);
        newCase.comment = ValueUpdater.updateNonNullableString(newCase.comment, source.comment);
        newCase.currencyCode = ValueUpdater.updateNullableString(newCase.currencyCode, source.currencyCode);
        newCase.dmsOrderNumber = ValueUpdater.updateNullableString(newCase.dmsOrderNumber, source.dmsOrderNumber);
        newCase.customerName = ValueUpdater.updateNullableString(newCase.customerName, source.customerName);
        newCase.customerLanguage = ValueUpdater.updateNullableString(newCase.customerLanguage, source.customerLanguage);
        newCase.dmsCustomerNumber = ValueUpdater.updateNullableString(newCase.dmsCustomerNumber, source.dmsCustomerNumber);
        newCase.gcdmCustomerId = ValueUpdater.updateNullableString(newCase.gcdmCustomerId, source.gcdmCustomerId);
        newCase.isDmsPreOrder = ValueUpdater.updateNonNullableBoolean(newCase.isDmsPreOrder, source.isDmsPreOrder);
        newCase.modifiedAt = ValueUpdater.updateNonNullableField(newCase.modifiedAt, ValueUpdater.getDateValue(source.modifiedAt));
        newCase.vinLong = ValueUpdater.updateNullableString(newCase.vinLong, source.vinLong);
        newCase.vinShort = ValueUpdater.updateNullableString(newCase.vinShort, source.vinShort);
        newCase.typeCode = ValueUpdater.updateNullableString(newCase.typeCode, source.typeCode);
        newCase.modelDesignation = ValueUpdater.updateNullableString(newCase.modelDesignation, source.modelDesignation);
        newCase.developmentCode = ValueUpdater.updateNullableString(newCase.developmentCode, source.developmentCode);
        newCase.hasWarnings = ValueUpdater.updateNonNullableBoolean(newCase.hasWarnings, source.hasWarnings);
        newCase.hasSalesStop = ValueUpdater.updateNonNullableBoolean(newCase.hasSalesStop, source.hasSalesStop);
        newCase.licensePlate = ValueUpdater.updateNullableString(newCase.licensePlate, source.licensePlate);
        newCase.schedulingInformation = SchedulingInformationV11.constructFromPlainObject(source.schedulingInformation);
        newCase.smallCosyImageUrl = ValueUpdater.updateNonNullableString(newCase.smallCosyImageUrl, source.smallCosyImageUrl);
        newCase.netPrice = ValueUpdater.updateNullableNumber(newCase.netPrice, source.netPrice);
        newCase.totalPrice = ValueUpdater.updateNullableNumber(newCase.totalPrice, source.totalPrice);
        newCase.customers = source.customers;
        newCase.customerLoadingError = source.customerLoadingError;
        return newCase;
    }
    constructor(externalId, title, createdAt, createdByUserId, createdByUserName, modifiedAt, assignedUserId, assignedUserName, jobs) {
        this.externalId = externalId;
        this.title = title;
        this.createdAt = createdAt;
        this.createdByUserId = createdByUserId;
        this.createdByUserName = createdByUserName;
        this.modifiedAt = modifiedAt;
        this.assignedUserId = assignedUserId;
        this.assignedUserName = assignedUserName;
        this.jobs = jobs;
        this.assignedDistributionPartnerNumber = '';
        this.assignedOutletNumber = '';
        this.assignedBusinessPartnerId = '';
        this.brand = null;
        this.comment = '';
        this.currencyCode = null;
        this.developmentCode = null;
        this.dmsOrderNumber = null;
        this.customerName = null;
        this.customerLanguage = null;
        this.dmsCustomerNumber = null;
        this.gcdmCustomerId = null;
        this.isDmsPreOrder = true;
        this.hasSalesStop = false;
        this.hasWarnings = false;
        this.licensePlate = null;
        this.modelDesignation = null;
        this.netPrice = null;
        this.smallCosyImageUrl = '';
        this.totalPrice = null;
        this.typeCode = null;
        this.vehicle = null;
        this.vinLong = null;
        this.vinShort = null;
        this.schedulingInformation = new SchedulingInformationV11();
    }
    getAssignedDistributionPartnerNumber() {
        return this.assignedDistributionPartnerNumber;
    }
    setAssignedDistributionPartnerNumber(assignedDistributionPartnerNumber) {
        this.assignedDistributionPartnerNumber = assignedDistributionPartnerNumber;
    }
    getAssignedOutletNumber() {
        return this.assignedOutletNumber;
    }
    setAssignedOutletNumber(assignedOutletNumber) {
        this.assignedOutletNumber = assignedOutletNumber;
    }
    getAssignedBusinessPartnerId() {
        return this.assignedBusinessPartnerId;
    }
    setAssignedBusinessPartnerId(businessPartnerId) {
        this.assignedBusinessPartnerId = businessPartnerId;
    }
    getAssignedUserId() {
        return this.assignedUserId;
    }
    setAssignedUserId(assignedUserId) {
        this.assignedUserId = assignedUserId;
    }
    getAssignedUserName() {
        return this.assignedUserName;
    }
    setAssignedUserName(assignedUserName) {
        this.assignedUserName = assignedUserName;
    }
    getComment() {
        return this.comment;
    }
    setComment(comment) {
        this.comment = comment;
    }
    getCustomers() {
        return this.customers;
    }
    setCustomers(customers) {
        this.customers = customers;
    }
    getCustomerLoadingError() {
        return this.customerLoadingError;
    }
    setCustomerLoadingError(customerLoadingError) {
        this.customerLoadingError = customerLoadingError;
    }
    getCreatedByUserId() {
        return this.createdByUserId;
    }
    setCreatedByUserId(createdByUserId) {
        this.createdByUserId = createdByUserId;
    }
    getCreatedByUserName() {
        return this.createdByUserName;
    }
    setCreatedByUserName(createdByUserName) {
        this.createdByUserName = createdByUserName;
    }
    getCurrencyCode() {
        return this.currencyCode;
    }
    setCurrencyCode(currencyCode) {
        this.currencyCode = currencyCode;
    }
    getCreatedAt() {
        return this.createdAt;
    }
    getDmsOrderNumber() {
        return this.dmsOrderNumber;
    }
    setDmsOrderNumber(dmsOrderNumber) {
        this.dmsOrderNumber = dmsOrderNumber;
    }
    getCustomerName() {
        return this.customerName;
    }
    setCustomerName(customerName) {
        this.customerName = customerName;
    }
    getCustomerLanguage() {
        return this.customerLanguage;
    }
    setCustomerLanguage(customerLanguage) {
        this.customerLanguage = customerLanguage;
    }
    getDmsCustomerNumber() {
        return this.dmsCustomerNumber;
    }
    setDmsCustomerNumber(dmsCustomerNumber) {
        this.dmsCustomerNumber = dmsCustomerNumber;
    }
    getGcdmCustomerId() {
        return this.gcdmCustomerId;
    }
    setGcdmCustomerId(gcdmCustomerId) {
        this.gcdmCustomerId = gcdmCustomerId;
    }
    getIsDmsPreOrder() {
        return this.isDmsPreOrder;
    }
    setIsDmsPreOrder(isDmsPreOrder) {
        this.isDmsPreOrder = isDmsPreOrder;
    }
    getExternalId() {
        return this.externalId;
    }
    setExternalId(externalId) {
        this.externalId = externalId;
    }
    getModifiedAt() {
        return this.modifiedAt;
    }
    setModifiedAt(modifiedAt) {
        this.modifiedAt = modifiedAt;
    }
    getTitle() {
        return this.title;
    }
    setTitle(title) {
        this.title = title;
    }
    getNetPrice() {
        return this.netPrice;
    }
    setNetPrice(netPrice) {
        this.netPrice = netPrice;
    }
    getSchedulingInformation() {
        return this.schedulingInformation;
    }
    setSchedulingInformation(schedulingInformation) {
        this.schedulingInformation = schedulingInformation;
    }
    getTotalPrice() {
        return this.totalPrice;
    }
    setTotalPrice(totalPrice) {
        this.totalPrice = totalPrice;
    }
    getJobs() {
        return this.jobs;
    }
    getVehicle() {
        return this.vehicle;
    }
    setVehicle(vehicle) {
        this.vehicle = vehicle;
    }
    getBrand() {
        return this.brand;
    }
    setBrand(brand) {
        this.brand = brand;
    }
    getVinLong() {
        return this.vinLong;
    }
    setVinLong(vinLong) {
        this.vinLong = vinLong;
    }
    getVinShort() {
        return this.vinShort;
    }
    setVinShort(vinShort) {
        this.vinShort = vinShort;
    }
    getLicensePlate() {
        return this.licensePlate;
    }
    setLicensePlate(licensePlate) {
        this.licensePlate = licensePlate;
    }
    getTypeCode() {
        return this.typeCode;
    }
    setTypeCode(typeCode) {
        this.typeCode = typeCode;
    }
    getModelDesignation() {
        return this.modelDesignation;
    }
    setModelDesignation(modelDesignation) {
        this.modelDesignation = modelDesignation;
    }
    getDevelopmentCode() {
        return this.developmentCode;
    }
    setDevelopmentCode(developmentCode) {
        this.developmentCode = developmentCode;
    }
    getHasWarnings() {
        return this.hasWarnings;
    }
    setHasWarnings(hasWarnings) {
        this.hasWarnings = hasWarnings;
    }
    getHasSalesStop() {
        return this.hasSalesStop;
    }
    setHasSalesStop(hasSalesStop) {
        this.hasSalesStop = hasSalesStop;
    }
    getSmallCosyImageUrl() {
        return this.smallCosyImageUrl;
    }
    setSmallCosyImageUrl(smallCosyImageUrl) {
        this.smallCosyImageUrl = smallCosyImageUrl;
    }
}
//# sourceMappingURL=caseV11.js.map